import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import HoldService from "../../src/Services/Hold.service";
const HoldLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        optionRenderer: function optionRenderer(hold) {
            return (_jsxs("span", { children: ["[", hold.srcSystemId, "] ", hold.name] }));
        },
        fetchItemsById: (ids) => {
            return HoldService.findAllById(ids);
        },
        fetchOptions: (search) => {
            return HoldService.getHolds(search);
        },
    });
};
export default HoldLookup;
